/**
 * @file
 * Attaches behaviors for Temoignages Paragraph
 */

!((Drupal, $) => {

  'use strict';
  Drupal.behaviors.paragraphTemoignages = {

    attach: function (context) {

      /**
       * Enable slick carousel
       * @param {object} $slickContainer the item container
       * @returns {void}
       */
      function enableSlickCarousel($slickContainer) {
        $slickContainer.slick({
          arrows: false,
          dots: true,
          infinite: true,
          autoplay:true,
          autoplaySpeed:4500,
          swipeToSlide: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        });
      }

      $(context).find('.js-temoignages-slick-slider').each(function () {
        enableSlickCarousel($(this));
      });
    }
  };
// eslint-disable-next-line no-undef
})(Drupal, jQuery);

